import React, { Fragment, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AOS from "aos";
import "aos/dist/aos.css";

const useStyles = makeStyles((theme) => ({
  container: {
    zIndex: 1,
    width: "100%",
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "5em 2em",
    position: "relative",
    "& p": {
      fontSize: "18px",
      color: "#000",
      margin: 0,

      [theme.breakpoints.down("md")]: {
        fontSize: "18px",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "16px",
      },
    },
    "& h3": {
      fontSize: "55px",
      marginTop: "20px",
      marginBottom: "10px",
      fontWeight: 600,
      lineHeight: 1.2,
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        letterSpacing: "-2px",
        fontSize: "30px",
      },
      [theme.breakpoints.down("sm")]: {
        letterSpacing: "-1px",
        fontSize: "22px",
      },
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "1350px",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },
  mainHeading: {
    width: "100%",
    textAlign: "center",
    letterSpacing: "-3.6px",
    fontSize: "92px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    lineHeight: 1.1,
    display: "block",

    [theme.breakpoints.down("md")]: {
      letterSpacing: "-2px",
      fontSize: "80px",
    },
    [theme.breakpoints.down("sm")]: {
      letterSpacing: "-1px",
      fontSize: "34px",
    },
  },
  gradientText: {
    backgroundImage: "linear-gradient(to right, #6557ff, #aa3fff 80%)",
    textAlign: "center",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
  },
  checkList: {
    gridColumnGap: "1em",
    gridRowGap: "1em",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginTop: "2em",
    marginBottom: 0,
    paddingLeft: 0,
    listStyleType: "none",
    display: "flex",
    "& li": {
      backgroundImage: "url(images/logged_out/Check-Icon.svg)",
      backgroundPosition: "3px",
      backgroundRepeat: "no-repeat",
      backgroundSize: "16px",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: "30px",
    },
  },
  gradientBG: {
    zIndex: -1,
    width: "100%",
    position: "absolute",
    top: 0,
    bottom: "-40%",
    left: 0,
    right: 0,

    "& div": {
      zIndex: -1,
      width: "100%",
      backgroundImage:
        "linear-gradient(130deg, #6557ff, #aa3fff 30%, #aa3fff 63%, #fcaa4a 81%)",
      opacity: 0.15,
      bottom: "20%",
      filter: "blur(100px)",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
    },
  },

  gridContainer: {
    display: "grid",
    gap: "3em",
    gridTemplateColumns: "1fr 1.5fr",

    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
    },
  },

  videoIframe: {
    aspectRatio: "16/9",
  },
}));

export default function CardSection() {
  const classes = useStyles();
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section style={{ position: "relative" }}>
      <Box className={classes.container}>
        <Typography
          className={classes.mainHeading}
          variant="h2"
          fontWeight={500}
          textAlign="center"
          data-aos="fade-up"
          data-aos-easing="ease-out"
          data-aos-delay="550"
        >
          Revolutionize University Admissions with{" "}
          <span className={classes.gradientText}>Expert Guidance</span>
        </Typography>
        <div
          style={{
            maxWidth: "690px",
            padding: "1rem 0",
            textAlign: "center",
            margin: "auto",
          }}
          data-aos="fade-up"
        >
          <p>
           College admissions to is a complex process. We're making it simple.
          </p>
        </div>
        <div className={classes.gridContainer}>
          <div
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="550"
            style={{ textAlign: "center" }}
          >
            <h3>
              Optimizing Interview Practice with{" "}
              <span className={classes.gradientText}>auralyze.ai</span>{" "}
            </h3>
            <p>
              Auralyze.ai simplifies the practice interview process,
              offering intuitive recording and reviewing features. With
              AI-powered feedback, candidates receive targeted insights to
              enhance their preparation, ensuring they enter their university
              interviews well-prepared and confident. With Auralyze.ai, they can
              effortlessly:
            </p>
            <ul
              data-aos="fade-up"
              data-aos-easing="ease-out"
              data-aos-delay="550"
              className={classes.checkList}
            >
              <li>Choose Subject</li>
              <li>Record Response</li>
              <li>Receive AI-Powered Feedback</li>
            </ul>
          </div>
          <div
            data-aos="zoom-in"
            data-aos-easing="ease-out"
            data-aos-delay="1000"
          >
            <iframe
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
              }}
              src="https://www.loom.com/embed/e267740d987c4787b2f9b6cb91265022?sid=cb4a640b-715e-4d4c-ab67-c1cdad7e1ced"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen=""
              title="Auralyze.ai Demo"
              className={classes.videoIframe}
            ></iframe>
          </div>
        </div>
      </Box>
      <div className={classes.gradientBG}>
        <div></div>
      </div>
    </section>
  );
}
